module.exports = __webpack_public_path__ + "static/media/sla.e3b15776.png";